import { createSlice } from "@reduxjs/toolkit";
import { getDocumentPhysicalDetails } from "./notes-selected-document-thunk";
import { getPageSlotHeight, isNonEmptyArray } from "../../../../common/utils";
import notesProvider from "../providers/notesProvider";
import { NavUtils } from "../../../../navigation";

const initialState = {
	selectedDocument: notesProvider.getSelectedDocument() || {},
	pageDimensions: [],
	numberOfPages: 0,
	currentReference: null,
};
const notesSelectedDocumentSlice = createSlice({
	name: "notesSelectedDocument",
	initialState,
	reducers: {
		setCurrentReference: (state, { payload }) => ({ ...state, currentReference: payload }),
		setSelectedDocument: (state, { payload }) => {
			notesProvider.setSelectedDocument(payload);
			return { ...state, selectedDocument: payload };
		},
		resetDocument: (state) => {
			notesProvider.setSelectedDocument({});
			return { ...state, selectedDocument: {}, pageDimensions: [], numberOfPages: 0 };
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getDocumentPhysicalDetails.fulfilled, (state, action) => {
			const { numberOfPages, pageDimensions, pageHigh, pageWidth, ...rest } = action.payload;
			let pDimensions = pageDimensions;
			if (!isNonEmptyArray(pageDimensions)) {
				pDimensions = Array.from({ length: numberOfPages }).fill({ width: pageWidth, height: pageHigh });
			}
			let accumulatedTop = 0;
			const pagesWithTop = pDimensions.map((page, index) => {
				const pageWithTop = { ...page, top: accumulatedTop, page: index + 1 };
				accumulatedTop += getPageSlotHeight(page);
				return pageWithTop;
			});
			return {
				...state,
				pageDimensions: pagesWithTop,
				numberOfPages,
				...rest,
			};
		});
		builder.addCase(getDocumentPhysicalDetails.rejected, (state, action) => {
			const { projectId } = action.meta.arg;
			window.history.pushState({}, "", NavUtils.goToNotes({ projectId }));
			return {
				...state,
				checkedNoDoc: true,
				selectedDocument: {},
			};
		});
	},
});
export { getDocumentPhysicalDetails };
export const { setSelectedDocument, resetDocument, setCurrentReference } = notesSelectedDocumentSlice.actions;
export default notesSelectedDocumentSlice.reducer;
